import React, { useState } from "react";

interface ShareRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  shareUrl:string;
}

const ShareRequestModal: React.FC<ShareRequestModalProps> = ({ isOpen, onClose, shareUrl }) => {
  const [copied, setCopied] = useState(false);
  if (!isOpen) return null;

 

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
      });
  };


  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center w-full overflow-y-auto overflow-x-hidden bg-black bg-opacity-50">
      <div className="relative p-4 w-full max-w-xl">
        {/* Modal content */}
        <div className="relative bg-white rounded-lg shadow">
          {/* Modal header */}
          <div className="flex items-center justify-between p-4 md:p-5 rounded-t">
            <h3 className="text-lg font-semibold text-grease-100">Share Your Request</h3>
            <button
              type="button"
              className="text-gray-400 bg-transparent rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
              onClick={onClose}
            >
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          {/* Modal body */}
          <div className="p-4 border-t">
            <p className="text-sm text-grease-200 font-semibold">
              Copy this link and share it on social media
            </p>
            <p className="text-sm text-grease-200 mt-3">
              Clicking the link will bring them to the app where they can answer your request.
            </p>
            <div className="bg-red-50 rounded-lg p-5 flex gap-4 mt-5">
              <i className="st-info text-2xl text-red-500"></i>
              <div>
                <p className="text-sm text-grease-200">
                  Your token will not be refunded because the loads for this flight are already available.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-5">
              <input
                type="text"
                value={shareUrl}
                className="block w-full p-3 border-none rounded-lg bg-lightblue-100 text-sm text-grease-100 focus:outline-none"
              />
                <div className="relative">
        <div 
          className="flex items-center justify-center px-4 py-2 rounded-lg bg-[#FFBC00] cursor-pointer"
          onClick={handleCopy}
        >
          <i className="st-copy text-xl text-white"></i>
        </div>
        {copied && (
          <div className="absolute bottom-full right-0 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded shadow-lg">
            Copied!
          </div>
        )}
      </div>
            </div>
            {/* <div className="flex items-center gap-4 mt-4">
              <div className="w-full h-0.25 bg-lightgray-100"></div>
              <p className="text-grease-100 text-xs">Or</p>
              <div className="w-full h-0.25 bg-lightgray-100"></div>
            </div>
            <button className="mt-5 flex gap-3 w-full p-2 items-center border border-lightgray-100 rounded-lg">
              <i className="st-share text-grease-100 text-lg"></i>
              <p className="text-grease-50">Share</p>
            </button>
            <button className="mt-5 flex gap-3 w-full p-2 items-center border border-royalblue-100 rounded-lg">
              <i className="st-fb text-blue-600 text-lg"></i>
              <p className="text-blue-600">Share on Facebook</p>
            </button> */}
          </div>
          <div className="flex gap-4 items-center justify-end p-4 md:p-5 border-t border-gray-200 rounded-b">
            {/* <button
              className="flex items-center gap-2 py-3 px-6 bg-indigo-100 rounded-lg"
              onClick={onClose}
            >
              <p className="font-medium bg-skyblue-200 text-grease-50 text-sm">Close</p>
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareRequestModal;
